// components/Auth/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';

const PrivateRoute = ({ element: Element }) => {
    let userProfile = useSelector((state) => state?.profile);
    userProfile = userProfile?.user;

    if (userProfile.ibType === 'NTP' || userProfile.ibType === 'CPL') {
        return <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />;
    }
    return <Element />;
};

export default PrivateRoute;
